import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, useLayoutEffect, useCallback } from 'react';
import classNames from 'classnames';
import styles from './ActionMenu.module.scss';
const ActionMenu = ({ onView, onDelete, onSetActive, options, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [openUpward, setOpenUpward] = useState(false);
    const menuRef = useRef(null);
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const updateMenuDirection = useCallback(() => {
        if (!isOpen || !buttonRef.current || !dropdownRef.current)
            return;
        const triggerRect = buttonRef.current.getBoundingClientRect();
        const dropdownHeight = dropdownRef.current.scrollHeight;
        const viewportPadding = 8;
        const spaceBelow = window.innerHeight - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        setOpenUpward(spaceBelow < dropdownHeight + viewportPadding && spaceAbove > spaceBelow);
    }, [isOpen]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    useLayoutEffect(() => {
        if (!isOpen)
            return;
        updateMenuDirection();
        window.addEventListener('resize', updateMenuDirection);
        window.addEventListener('scroll', updateMenuDirection, true);
        return () => {
            window.removeEventListener('resize', updateMenuDirection);
            window.removeEventListener('scroll', updateMenuDirection, true);
        };
    }, [isOpen, updateMenuDirection]);
    return (_jsxs("div", { className: styles.actionMenuContainer, ref: menuRef, children: [_jsx("button", { ref: buttonRef, onClick: () => setIsOpen(!isOpen), className: styles.menuButton, "aria-expanded": isOpen, "aria-haspopup": "menu", children: "\u22EF" }), isOpen && (_jsx("div", { ref: dropdownRef, className: classNames(styles.dropdownMenu, openUpward && styles.dropdownMenuUp), children: options && options.length > 0 ? (options.map((option, index) => (_jsx("button", { onClick: () => {
                        option.onClick();
                        setIsOpen(false);
                    }, className: classNames(styles.menuItem, option.color === 'red' && styles.delete), children: option.label }, index)))) : (_jsxs(_Fragment, { children: [onSetActive && (_jsx("button", { onClick: () => {
                                onSetActive();
                                setIsOpen(false);
                            }, className: styles.menuItem, children: "Set to Active" })), onView && (_jsx("button", { onClick: () => {
                                onView();
                                setIsOpen(false);
                            }, className: styles.menuItem, children: "View Details" })), onDelete && (_jsx("button", { onClick: () => {
                                onDelete();
                                setIsOpen(false);
                            }, className: classNames(styles.menuItem, styles.delete), children: "Delete Account" }))] })) }))] }));
};
export default ActionMenu;
